import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
function getTargetDate(): Date {
  const target = new Date();
  target.setDate(target.getDate() + 3);
  target.setHours(20, 0, 0, 0);
  return target;
}
function calculateTimeLeft(targetDate: Date): TimeLeft {
  const diff = targetDate.getTime() - new Date().getTime();
  if (diff <= 0) return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor(diff / (1000 * 60 * 60) % 24),
    minutes: Math.floor(diff / (1000 * 60) % 60),
    seconds: Math.floor(diff / 1000 % 60)
  };
}
function pad(n: number): string {
  return String(n).padStart(2, '0');
}
export function TopBar() {
  const [targetDate] = useState<Date>(getTargetDate);
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => calculateTimeLeft(getTargetDate()));
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate));
    }, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);
  return <motion.div initial={{
    y: -60,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} style={{
    background: 'linear-gradient(90deg, #0a0a0f 0%, #12001f 50%, #0a0a0f 100%)',
    borderBottom: '1px solid rgba(0,242,234,0.15)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    width: '100%'
  }} data-id="element-98">
      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '6px'
    }} data-id="element-99">
        {/* Left: LIVE indicator */}
        <div className="topbar-left" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexShrink: 0
      }} data-id="element-100">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }} data-id="element-101">
            <div className="pulse-red" style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            background: '#f22a72',
            boxShadow: '0 0 8px rgba(242,42,114,0.8)'
          }} data-id="element-102" />
            <span style={{
            background: '#f22a72',
            color: 'white',
            fontSize: '11px',
            fontWeight: 900,
            fontFamily: 'Poppins, sans-serif',
            padding: '2px 8px',
            borderRadius: '4px',
            letterSpacing: '0.1em'
          }} data-id="element-103">
              EN VIVO
            </span>
          </div>
          <span className="topbar-label" style={{
          color: '#a0a0b0',
          fontSize: '13px',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-104">
            Próxima sesión del Masterclass de Tiktok Shop Afiliados
          </span>
        </div>

        {/* Center: Countdown */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
      }} data-id="element-105">
          {[{
          value: timeLeft.days,
          label: 'días'
        }, {
          value: timeLeft.hours,
          label: 'hrs'
        }, {
          value: timeLeft.minutes,
          label: 'min'
        }, {
          value: timeLeft.seconds,
          label: 'seg'
        }].map((item, i) => <div key={item.label} style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }} data-id="element-106">
              <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            background: 'rgba(24,163,159,0.08)',
            border: '1px solid rgba(24,163,159,0.25)',
            borderRadius: '6px',
            padding: '4px 6px',
            minWidth: '36px'
          }} data-id="element-107">
                <span className="countdown-digit" data-id="element-108">{pad(item.value)}</span>
                <span style={{
              color: '#6b6b80',
              fontSize: '9px',
              fontFamily: 'Inter, sans-serif',
              letterSpacing: '0.05em'
            }} data-id="element-109">
                  {item.label}
                </span>
              </div>
              {i < 3 && <span style={{
            color: 'var(--color-teal)',
            fontWeight: 900,
            fontSize: '18px',
            marginBottom: '8px'
          }} data-id="element-110">
                  :
                </span>}
            </div>)}
        </div>

        {/* Right: Scarcity */}
        <div className="topbar-scarcity" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        flexShrink: 0
      }} data-id="element-111">
          <ZapIcon size={14} color="var(--color-yellow)" data-id="element-112" />
          <span style={{
          color: 'var(--color-yellow)',
          fontSize: '13px',
          fontWeight: 700,
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-113">
            Solo quedan <strong data-id="element-114">47 cupos</strong> disponibles
          </span>
        </div>
      </div>

      <style data-id="element-115">{`
        @media (max-width: 640px) {
          .topbar-label { display: none !important; }
          .topbar-scarcity { display: none !important; }
          .topbar-left { justify-content: center; }
          .countdown-digit { font-size: 1.1rem !important; }
        }
      `}</style>
    </motion.div>;
}